<template>
  <div class="w-full">
    <vs-card
      id="invoiced-expense-donut-loading"
      class="vs-con-loading__container px-2 widget-card altura ligthMode darkModeCard"
      style="position: sticky"
    >
      <vs-row>
        <vs-col>
          <card-header :title="$t('invoiced_expenses_by_client')"></card-header>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col>
          <div class="body-card-widget">
            <vue-apex-charts
              class="mt-12 mb-8"
              type="donut"
              height="250%"
              :options="chartOptions"
              :series="series"
            />
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import CardHeader from './CardHeader.vue'
//requests
import request from '@/http/requests/dashboard'
//mixins
import loading from '@/mixins/Loading.js'

export default {
  mixins: [loading],
  props:{
    refresh:{
      type:Boolean,
      default:false,
    }
  },
  components: {
    VueApexCharts,
    CardHeader,
  },

  data() {
    return {
      chartOptions: {
        background: '#1A1D2F',
        labels: [],
        legend: {
          show: false,
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  formatter: function (w) {
                    let total = 0
                    let number
                    let numberOut = 0
                    w.globals.seriesTotals.forEach((element) => {
                      total = total + parseInt(element)
                    })

                    return total
                  },
                },
                name: {
                  show: false,
                },
                value: {
                  show: true,
                  fontSize: '30px',
                  color: '#fff',
                  formatter(val, w, label) {
                    let total = 0
                    w.globals.seriesTotals.forEach((element) => {
                      total = total + parseInt(element)
                    })
                    return val
                  },
                },
              },
            },
          },
        },
        chart: {
          id: 'donut-invoiced-expense',
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          marker: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke:{
         colors:['#273045']
        },
      },
      series: [],
      colors: [],
      ExpenseData: [],
      loading: {
        invoiced_expense_donut: false,
      },
      params: {
        page: 1,
        search: '',
        sortBy: ['Expenses.ReceivedDate'],
        sort: ['DESC'],
        StatusDonutId: 'invoicedDonut',
        ClientName: null,
        StatusId: [6],
      }
    }
  },
  computed: {
    isLoading() {
      return this.loading.invoiced_expense_donut
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('invoiced-expense-donut-loading')
      } else {
        this.closeLoading('invoiced-expense-donut-loading')
      }
    },
  },
  mounted() {
    this.getInfo()
    if(this.refresh === true){
      var v = this
      setInterval(function () {
        v.getInfo()
      }, process.env.VUE_APP_CHART_RELOAD_TIME)
    }
  },
  methods: {
    getInfo() {
      this.loading.invoiced_expense_donut = true
      request
        .invoicedExpenseData()
        .then((res) => {
          this.ExpenseData = res.data.data
          this.fillDonutTotales()
        })
        .catch((err) => {
          console.log(err)
          this.loading.invoiced_expense_donut = false
        })
    },

    fillDonutTotales() {
      if (this.ExpenseData.length == 0) {
        this.series = [1]
        this.chartOptions.labels = ['NO INFO']
        this.colors = ['#626262']
        this.resertDonut()
      } else {
        for (let i = 0; i < this.ExpenseData.length; i++) {
          this.chartOptions.labels[i] = this.ExpenseData[i].ClientName
          this.series[i] = parseInt(this.ExpenseData[i].Amount)
          this.colors[i] = this.ExpenseData[i].color
        }
        this.resertDonut()
      }
    },
    resertDonut() {
      ApexCharts.exec(
        'donut-invoiced-expense',
        'updateOptions',
        {
          fill: {
            colors: this.colors,
          },
          labels: this.chartOptions.labels,
          series: this.series,
        },
        (this.loading.invoiced_expense_donut = false)
      )
    }
  },
}
</script>
<style>
</style>
